import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ModalComponent } from "src/app/core/components/modal/modal.component";
import { RootStoreState } from "src/app/root-store";
import { GetProductsList } from "src/app/root-store/kwikspace-app-store/actions/floorplanner.action";
import {
  getProductsList,
  getProductsListError,
  getProductsListLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/floorplanner.selector";
import {
  CreatePurchaseLineItem,
  CreatePurchaseLineItemConfig,
  GetFpProjectPriceLists,
  GetMatchedPurchasePricing,
} from "src/app/root-store/kwikspace-app-store/actions/purchase.action";
import {
  getCreatedLineItemConfigsLoading,
  getCreatedLineItemConfigsError,
  // getCreatedLineItemsError,
  // getCreatedLineItemsLoading,
  getCreatedLineItemsSuccess,
  getMatchedPricing,
  getMatchedPricingError,
  getMatchedPricingLoading,
  // getCreatedLineItems,
  getCreatedLineItemConfigs,
  getFpProjectPriceList,
} from "src/app/root-store/kwikspace-app-store/selectors/purchase.selector";
import { AppRoutes } from "src/app/shared/endpoints.enum";
import { Transport } from "src/app/models/Transport.model";
import { getCreatedPurchaseQuote } from "src/app/root-store/kwikspace-app-store/selectors/quote.selector";
import {
  ClearTransportPriceList,
  GetTransportAreas,
  GetTransportLoads,
  GetTransportOptions,
  GetTransportPriceList,
} from "src/app/root-store/kwikspace-app-store/actions/transport.action";
import {
  getTransportAreas,
  getTransportAreasError,
  getTransportAreasLoading,
  getTransportLoads,
  getTransportLoadsError,
  getTransportLoadsLoading,
  getTransportOptions,
  getTransportOptionsError,
  getTransportOptionsLoading,
  getTransportPriceList,
  getTransportPriceListError,
  getTransportPriceListLoading,
} from "src/app/root-store/kwikspace-app-store/selectors/transport.selector";

@Component({
  selector: "app-purchase-quote-config",
  templateUrl: "./purchase-quote-config.component.html",
  styleUrls: ["./purchase-quote-config.component.scss"],
})
export class PurchaseQuoteConfigComponent implements OnInit {
  private ngUnsubscribe = new Subject();

  @Input() currentProject;

  // @Input() createdQuote;

  // productsLoading$: Observable<any> = this.store.select(getProductsListLoading);
  // productsError$: Observable<any> = this.store.select(getProductsListError);

  // matchedProductPricingLoading$: Observable<any> = this.store.select(
  //   getMatchedPricingLoading
  // );
  // matchedProductPricingError$: Observable<any> = this.store.select(
  //   getMatchedPricingError
  // );

  // purchaseLineItemLoading$: Observable<any> = this.store.select(
  //   getCreatedLineItemsLoading
  // );
  // purchaseLineItemError$: Observable<any> = this.store.select(
  //   getCreatedLineItemsError
  // );

  // purchaseLineItemConfigLoading$: Observable<any> = this.store.select(
  //   getCreatedLineItemConfigsLoading
  // );
  // purchaseLineItemConfigError$: Observable<any> = this.store.select(
  //   getCreatedLineItemConfigsError
  // );

  // transportPricingLoading$: Observable<any> = this.store.select(
  //   getTransportPriceListLoading
  // );
  // transportPricingError$: Observable<any> = this.store.select(
  //   getTransportPriceListError
  // );

  // transportOptionsLoading$: Observable<any> = this.store.select(
  //   getTransportOptionsLoading
  // );
  // transportOptionsError$: Observable<any> = this.store.select(
  //   getTransportOptionsError
  // );

  // transportLoadsLoading$: Observable<any> = this.store.select(
  //   getTransportLoadsLoading
  // );
  // transportLoadsError$: Observable<any> = this.store.select(
  //   getTransportLoadsError
  // );

  // transportAreasLoading$: Observable<any> = this.store.select(
  //   getTransportAreasLoading
  // );
  // transportAreasError$: Observable<any> = this.store.select(
  //   getTransportAreasError
  // );

  quoteNumber: any = null;
  createdQuote: any = null;
  canSave: boolean = true;

  selectedProject: any = null;
  selectedQuote: any = null;
  // projectProducts: any[] = [];
  // matchedProducts: any[] = [];
  matchedPricings: any[] = [];

  transportPricing: Transport[] = [];
  transportVariations: any[] = [];
  transportLoads: any[] = [];
  transportLoadError: boolean = false;
  // transportAreas: any[] = [];

  // hasPricing: boolean = false;
  // hasTransportArea: boolean = false;
  hasTransportPricing: boolean = false;
  // retryAreas: boolean = false;

  // selectedTransport: any = null;
  // selectedTransportArea = null;
  // selectedTransportLoad = null;
  // selectedTransportOption = null;
  // selectedTransportJoinOption = null;
  // selectedTransportExtraOption = null;
  // selectedTransportExtraCount = 0;

  // showTransportCharge: boolean = false;

  // purchaseForm: FormGroup;

  // quoteCart: any[] = [];
  // quoteLineItem = null;
  createdLineItem = null;

  configsToAdd = 0;

  constructor(
    private store: Store<RootStoreState.RootState>,
    private router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    // TODO
    /*
    - get created quote
      - if current quote has shipping and is SA province
        - xx get transport loads
        - xx calculate load size
        - xx get transport options - variation
        - get transport area // this should be on the created quote object already
        - calculate transport charge - transport, join, charge // get the transport pricing - just uncomment the code
      - else
        - continue
    - get current project
      - if project is not template
        - get shell pricing
        - get products
        - asset price match
      - else
        - get pricelist for this project
      
    - show confirmation screen
    - create line item
    - create product configuration for line item

     */
    this.selectedProject = this.currentProject;

    // this.store.dispatch(new GetProductsList(this.selectedProject.projectId));

    // this.store
    //   .select(getProductsList)
    //   .pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((products: any) => {
    //     if (products && products.length > 0) {
    //       this.projectProducts = this.addProjectProductsToArray(products);

    //       this.getMatchedProductsPricing(this.projectProducts);
    //     }
    //   });

    this.store
      .select(getCreatedPurchaseQuote)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((quote) => {
        if (quote) {
          this.createdQuote = quote;
          this.quoteNumber = this.createdQuote.quote_number;

          if (
            this.createdQuote.shipping_province != null &&
            this.createdQuote.shipping == true
          ) {
            // this.getTransportLoads();
          }
        }
      });
  }

  // getTransportLoads() {
  //   // this.store.dispatch(new GetTransportOptions());
  //   this.store.dispatch(new GetTransportLoads());
  //   // this.store.dispatch(new GetTransportAreas({}));

  //   this.store
  //     .select(getTransportLoads)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((loads: any) => {
  //       if (loads && loads.length > 0) {
  //         this.transportLoads = loads.filter(
  //           (loadSize) => loadSize.available == true
  //         );

  //         if (this.transportLoads.length > 0) {
  //           const hasLoad = this.calculateLoadSize();

  //           if (hasLoad) {
  //             this.getTransportVariations();
  //           }
  //         }
  //       }
  //     });

  // this.store
  //   .select(getTransportOptions)
  //   .pipe(takeUntil(this.ngUnsubscribe))
  //   .subscribe((options: any) => {
  //     if (options) {
  //       this.transportOptions = options;
  //     }
  //   });

  // this.store
  //   .select(getTransportLoads)
  //   .pipe(takeUntil(this.ngUnsubscribe))
  //   .subscribe((loads: any) => {
  //     if (loads) {
  //       this.transportLoads = loads;
  //     }
  //   });

  // this.store
  //   .select(getTransportAreas)
  //   .pipe(takeUntil(this.ngUnsubscribe))
  //   .subscribe((areas: any) => {
  //     if (areas) {
  //       let _areas = areas;
  //       let provinceId = this.createdQuote.shipping_province;

  //       if (this.retryAreas) {
  //         this.transportAreas = areas;
  //       } else {
  //         this.transportAreas = _areas.filter(prov => prov.district.province.id == provinceId);
  //       }
  //       if (this.transportAreas.length > 0) {
  //         this.hasTransportArea = true;
  //       }
  //     }
  //   });
  // }

  // getTransportVariations() {
  //   this.store.dispatch(new GetTransportOptions());

  //   this.store
  //     .select(getTransportOptions)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((options: any) => {
  //       if (options && options.length > 0) {
  //         this.transportVariations = options;
  //         let transportId: any = null;
  //         let transportJoinId: any = null;
  //         let transportChargeList: any = [];

  //         this.transportVariations.forEach((option) => {
  //           if (option.name == "Transport") {
  //             transportId = option.id;
  //           } else if (
  //             this.hasJoining() &&
  //             option.name == "Travel & Siting (Joining) on site"
  //           ) {
  //             transportJoinId = option.id;
  //           } else {
  //             transportChargeList.push(option.name);
  //           }
  //         });

  //         this.selectedTransportOption = transportId;
  //         this.selectedTransportJoinOption = transportJoinId;
  //         this.selectedTransportExtraOption =
  //           this.getOptionalTransportFee(transportChargeList);

  //         if (this.selectedTransportOption != null) {
  //           this.getTransportPricing();
  //           // this.getTemplateProjectPricing();
  //         }
  //       }
  //     });
  // }

  // getOptionalTransportFee(transportChargeList) {
  //   let count = 0;
  //   let id = null;
  //   const projectCharge = this.selectedProject.variation.toLowerCase();

  //   if (this.selectedProject.isTemplate) {
  //     let charge = projectCharge.search(",");

  //     if (charge == -1) {
  //       // there is only one charge
  //       if (projectCharge != "standard") {
  //         id = this.transportVariations.findIndex(
  //           (obj) => obj.name.toLowerCase() == projectCharge
  //         );
  //       }
  //     } else {
  //       // there is more than one charge
  //       transportChargeList.forEach((name) => {
  //         const transportCharge = name.toLowerCase();
  //         count =
  //           transportCharge.search(projectCharge) != -1 ? (count += 1) : count;
  //       });

  //       let _id = this.transportVariations.findIndex((obj) => obj.id == 1);
  //     }
  //   }

  //   return id;
  // }

  // getTransportPricing() {
  //   this.store.dispatch(new ClearTransportPriceList());
  //   this.store
  //     .select(getTransportPriceList)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((transports: any) => {
  //       if (transports && transports.results) {
  //         if (transports.results.length > 0) {
  //           this.transportPricing = [];

  //           transports.results.forEach((price) => {
  //             if (
  //               price.priceType.name == "Both" ||
  //               price.priceType.name == "Purchase"
  //             ) {
  //               if (
  //                 price.transportCharge.name == "Transport" ||
  //                 price.transportCharge.name ==
  //                   "Travel & Siting (Joining) on site"
  //               ) {
  //                 this.transportPricing.push(price);
  //               }
  //             }
  //           });

  //           this.hasTransportPricing =
  //             this.transportPricing.length > 0 ? true : false;
  //           // this.setTransportPricing();
  //         }
  //       }
  //     });
  //   const params = `?load_size=${this.selectedTransportLoad}&transport_location=${this.createdQuote.shipping_area}`;
  //   this.store.dispatch(new GetTransportPriceList(params));
  // }

  // getTemplateProjectPricing() {
  //   this.store
  //     .select(getFpProjectPriceList)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((pricing: any) => {
  //       if (pricing) {
  //         if (pricing.length > 0) {
  //           debugger;
  //         }
  //       }
  //     });

  //   const payload = {
  //     category: `?category=${this.selectedProject.templateSelection.category}`,
  //     sub_category: `&sub_category=${this.selectedProject.templateSelection.subCategory}`,
  //     size: `&size=${this.selectedProject.templateSelection.size}`,
  //     variation: `&charge_variation=${this.selectedProject.templateSelection.variation}`,
  //   };
  //   this.store.dispatch(new GetFpProjectPriceLists(payload));
  // }

  // getTransportAllPricing() {
  //   if (
  //     this.selectedTransportLoad &&
  //     this.selectedTransportOption &&
  //     this.selectedTransportArea
  //   ) {
  //     this.store.dispatch(new ClearTransportPriceList());

  //     this.store
  //       .select(getTransportPriceList)
  //       .pipe(takeUntil(this.ngUnsubscribe))
  //       .subscribe((transports: any) => {
  //         if (transports && transports.results) {
  //           this.transportPricing = transports.results;
  //           this.hasTransportPricing =
  //             this.transportPricing.length > 0 ? true : false;
  //         }
  //       });

  //     this.store.dispatch(new GetTransportPriceList(null));
  //   }
  // }

  // getTransportAreas() {
  //   this.store.dispatch(new GetTransportAreas({}));
  //   this.retryAreas = true;
  // }

  // setSelectedTransportLoad() {
  //   this.selectedTransportLoad = this.purchaseForm.value.transport_load;

  //   this.getTransportPriceOptions();
  // }

  // setSelectedTransportArea() {
  //   this.selectedTransportArea = this.purchaseForm.value.transport_area;

  //   this.getTransportPriceOptions();
  // }

  // setSelectedTransportOption() {
  //   this.selectedTransportOption = this.selectedTransportOption ? this.selectedTransportOption : this.purchaseForm.value.transport_option;

  //   this.getTransportPriceOptions();
  // }

  // getTransportPriceOptions() {
  //   if (
  //     this.selectedTransportLoad &&
  //     this.selectedTransportOption
  //   ) {
  //     this.store.dispatch(new ClearTransportPriceList());

  //     this.store
  //       .select(getTransportPriceList)
  //       .pipe(takeUntil(this.ngUnsubscribe))
  //       .subscribe((transports: any) => {
  //         if (transports && transports.results) {
  //           if (transports.results.length > 0) {
  //             this.transportPricing = [];

  //             transports.results.forEach((price) => {
  //               if (
  //                 price.priceType.name == "Both" ||
  //                 price.priceType.name == "Purchase"
  //               ) {
  //                 if (
  //                   price.transportCharge.name == "Transport" ||
  //                   price.transportCharge.name == "Travel & Siting (Joining) on site"
  //                 ) {
  //                   this.transportPricing.push(price);
  //                 }
  //               }
  //             });

  //             this.hasTransportPricing =
  //               this.transportPricing.length > 0 ? true : false;
  //             // this.setTransportPricing();
  //           }
  //         }
  //       });
  //     const params = `?load_size=${this.selectedTransportLoad}&transport_location=${this.createdQuote.shipping_area}`;
  //     this.store.dispatch(new GetTransportPriceList(params));
  //   }
  // }

  // setTransportOption() {
  //   let transportId = this.purchaseForm.value.purchase_transport;
  //   let _id = this.transportPricing.findIndex((obj) => obj.id == transportId);
  //   this.selectedTransport = this.transportPricing[_id];

  //   let transport = {
  //     id: transportId,
  //     transport: this.selectedTransport,
  //   };

  //   this.selectedProject.transport = transport;
  // }

  // addProjectProductsToArray(products) {
  //   let _productList = [];
  //   products.forEach((product) => {
  //     _productList.push(product.sku);
  //   });

  //   return _productList;
  // }

  // getMatchedProductsPricing(products) {
  //   let payload = {
  //     products: products,
  //   };

  //   this.store.dispatch(new GetMatchedPurchasePricing(payload));

  //   this.store
  //     .select(getMatchedPricing)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((pricelist: any) => {
  //       if (pricelist) {
  //         this.matchedProducts = pricelist;
  //         this.matchPricing();
  //       }
  //     });
  // }

  // matchPricing() {
  //   let _matchedPricings = [];

  //   this.projectProducts.forEach((item) => {
  //     let pricedItem = this.matchedProducts.filter(
  //       (apiItem) => apiItem.floor_PlannerSku == item
  //     );

  //     _matchedPricings.push(pricedItem);
  //   });

  //   this.matchedPricings = _matchedPricings;
  // }

  // completeQuote() {
  //   this.saveLineItem();
  // }

  // saveLineItem() {
  //   // const item = this.quoteCart[0];
  //   const payload = {};

  //   this.store.dispatch(new CreatePurchaseLineItem(payload));

  //   this.store
  //     .select(getCreatedLineItemsSuccess)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((lineitem: any) => {
  //       if (lineitem) {
  //         if (this.matchedPricings.length == 0) {
  //           const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
  //           this.router.navigate([route]);
  //         }
  //       }
  //     });

  //   this.store
  //     .select(getCreatedLineItems)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((lineitems: any) => {
  //       if (lineitems && lineitems.length > 0) {
  //         this.createdLineItem = lineitems[0];

  //         if (this.matchedPricings.length == 0) {
  //           const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
  //           this.router.navigate([route]);
  //         } else {
  //           this.saveProductConfigItems();
  //         }
  //       }
  //     });
  // }

  // saveProductConfigItems() {
  //   let addon = this.matchedPricings[0];
  //   this.saveConfigItem(addon);

  //   this.store
  //     .select(getCreatedLineItemConfigs)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe((configs) => {
  //       if (configs) {
  //         console.log("..configs", configs);

  //         let configsAdded = configs.length;
  //         this.configsToAdd = this.matchedPricings.length;

  //         if (this.configsToAdd == configsAdded) {
  //           const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
  //           this.router.navigate([route]);
  //         } else {
  //           if (configsAdded > 0) {
  //             let itemIdx = this.matchedPricings[configsAdded];
  //             this.saveConfigItem(itemIdx);
  //           }
  //         }
  //       }
  //     });
  // }

  // saveConfigItem(item) {
  //   const line_item = this.createdLineItem.id;

  //   const payload = {};

  //   this.store.dispatch(new CreatePurchaseLineItemConfig(payload));
  // }

  // hasJoining() {
  //   let join = false;

  //   if (this.selectedProject.isTemplate) {
  //     const size = this.selectedProject.size;

  //     let min = size.split("m x")[0];
  //     min = parseInt(min);

  //     join = min > 3 ? true : false;
  //   }

  //   return join;
  // }

  // calculateLoadSize() {
  //   let match;
  //   const size = this.selectedProject.size;

  //   let min = size.split("m x")[0];
  //   let max = size.split("x")[1];
  //   max = max.replace("m", "");
  //   min = parseInt(min);
  //   max = parseInt(max);

  //   // look for an exact match
  //   match = this.getPerfectMatch(min, max);

  //   if (match != null) {
  //     this.selectedTransportLoad = match;

  //     return true;
  //   } else {
  //     // no exact match found, look for closest match
  //     match = this.findClosestMatch(min, max);
  //     if (match != null) {
  //       this.selectedTransportLoad = match;

  //       return true;
  //     } else {
  //       // no matches found, select load size manually
  //       this.transportLoadError = true;

  //       return false;
  //     }
  //   }
  // }

  // getPerfectMatch(unitWidth, unitLength) {
  //   let _id = null;

  //   for (let i = 0; i < this.transportLoads.length; i++) {
  //     let loadSize = this.transportLoads[i].size;

  //     let length = loadSize.split("m x")[0].replace(/\s/g, "");
  //     let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
  //     length = parseInt(length);
  //     width = parseInt(width);

  //     if (unitWidth == width && unitLength == length) {
  //       _id = this.transportLoads[i].id;
  //       break;
  //     }
  //   }

  //   return _id;
  // }

  // findClosestMatch(unitWidth, unitLength) {
  //   let _id = null;
  //   let matchedItems = [];

  //   for (let i = 0; i < this.transportLoads.length; i++) {
  //     let loadSize = this.transportLoads[i].size;

  //     let length = loadSize.split("m x")[0].replace(/\s/g, "");
  //     let width = loadSize.split("x")[1].replace(/\s/g, "").charAt(0);
  //     length = parseInt(length);
  //     width = parseInt(width);

  //     if (unitLength <= length && unitWidth <= width) {
  //       matchedItems.push(this.transportLoads[i]);
  //     }
  //   }

  //   if (matchedItems.length > 0) {
  //     matchedItems.sort((a, b) => (a.size > b.size ? 1 : -1));
  //     _id = matchedItems[0].id;
  //   }

  //   return _id;
  // }

  // ngOnDestroy() {
  //   this.ngUnsubscribe.next();
  //   this.ngUnsubscribe.complete();
  // }
}
